import { useEffect } from 'react'
import HeaderImage from '../../assets/me.JPG'
import data from './data'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './header.css'

const Header = () => {
  useEffect(() => {
    AOS.init({duration: 2000})
  }, [])

  return (
    <header id="header">
      <div className="container header__container">
        <div className="header__profile" data-aos="fade-in">
          <img src={HeaderImage} alt="Header Portait" />
        </div>
        <h3  data-aos="fade-up">Serwin Kastaneer</h3>
        <p  data-aos="fade-up">
       Welcome to my portfolio website. I am a Software Eningeer with experience working at a start up company. I will be sharing every side projects that I completed on this website.
        </p>
        <div className="header__cta"  data-aos="fade-up">
          <a href="#about" className='btn primary'>About Me</a>
          <a href="#portfolio" className='btn light'>My Work</a>
        </div>
        <div className="header__socials">
          {
            data.map(item => <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer">{item.icon}</a>)
          }
        </div>
      </div>
    </header>
  )
}

export default Header